module.exports = __webpack_public_path__ + "img/me.d60e04c2.png";